export default __webpack_public_path__ + "static/media/shopee.3bd0dee3.png";